import { ChatChannelIds, ChatMessageRelationType, ChatMessage as ChatMessageType } from '@core/types';
import { useState } from 'react';
import { OpenChatMessageMenu } from '../../../types/components/OpenChatMessageMenu';
import { ActiveChatChannel } from '../../molecules/ActiveChatChannel';
import { ChatChannelSendMessage } from '../../molecules/ChatChannelSendMessage';
import { ChatChannelsTabs } from '../../molecules/ChatChannelsTabs';
import { ChatMessageMenu } from '../../molecules/ChatMessageMenu';

export const ChatChannels = () => {
    const [activeChannel, setActiveChannel] = useState<string>(ChatChannelIds.publicChannel);
    const [relatedMessage, setRelatedMessage] = useState<ChatMessageType | null>(null);
    const [relationType, setRelationType] = useState<ChatMessageRelationType | null>(null);
    const [openChatMessageMenu, setOpenChatMessageMenu] = useState<OpenChatMessageMenu | null>(null);

    return (
        <div className="w-full h-full bg-white grid grid-rows-[auto_1fr_auto_auto]">
            <ChatChannelsTabs onActiveChannelChange={setActiveChannel} activeChannelId={activeChannel} />
            <ActiveChatChannel channelId={activeChannel || ''} openChatMessageMenu={openChatMessageMenu} setOpenChatMessageMenu={setOpenChatMessageMenu} />
            {openChatMessageMenu && (
                <ChatMessageMenu
                    message={openChatMessageMenu}
                    onClose={() => setOpenChatMessageMenu(null)}
                    setRelatedMessage={setRelatedMessage}
                    setRelationType={setRelationType}
                    setActiveChannel={setActiveChannel}
                />
            )}
            <ChatChannelSendMessage channelId={activeChannel || ''} relatedMessage={relatedMessage} relationType={relationType} />
        </div>
    );
};
